// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"36a31b51","261":"287afbe1"}[chunkId] + ".chunk.css";
};